import { useNavigate } from 'react-router-dom';
import './Header.css';
import MobileBottomNav from './MobileBottomNav';

const StarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);
const PersonIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
  </svg>
);

const Header = ({ activeScreen, setActiveScreen, spotlightMode = false }) => {
  const navigate = useNavigate();

  const handleNavClick = (e, screen) => {
    e.preventDefault();
    setActiveScreen(screen);
  };

  return (
    <>
      <header className="main-header">
        <div className="container-fluid main-header-container">
          <div className="row align-items-center">
            <div className="col-12">
              <nav className="main-header-nav">
                {/* Logo */}
                <div className="main-header-logo-wrapper" onClick={() => setActiveScreen('featured-athletes')} style={{ cursor: 'pointer' }}>
                  <img
                    src="/assets/images/logo.png"
                    alt="LegacyStat"
                    className="main-header-logo-image main-header-logo-desktop"
                  />
                  <img
                    src="/assets/images/logo.png"
                    alt="LegacyStat"
                    className="main-header-logo-image main-header-logo-mobile"
                  />
                </div>

                {/* Mobile Tab Pills (shown only on mobile via CSS) */}
                <div className="main-header-mobile-tabs">
                  <div className="main-header-tab-group">
                    <button className="main-header-tab-btn main-header-tab-active">
                      <StarIcon /> Spotlight
                    </button>
                    <button className="main-header-tab-btn" onClick={() => navigate('/standouts')}>
                      <PersonIcon /> Standouts
                    </button>
                  </div>
                </div>

                {/* Get Featured — right side */}
                <div className="main-header-nav-links">
                  <a
                    href="/get-featured"
                    className={`main-header-nav-link ${activeScreen === 'get-featured' ? 'active' : ''}`}
                    onClick={(e) => { e.preventDefault(); navigate('/get-featured'); }}
                  >
                    Get Featured
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav activeTab={activeScreen} setActiveTab={setActiveScreen} />
    </>
  );
};

export default Header;
